import { FlexBox, Box, AlertBox, Link, Button, Typography, Icon } from '@vp/swan';
import React, { useContext, useState, useEffect } from 'react';
import ConversationEvent from './src-components-ConversationEvent-ConversationEvent.js';
import { useCustomTracking } from './src-hooks-custom-hooks-useTracking.js';
import FeedbackPopover from './src-components-MessageFeedback-FeedbackPopover.js';
import './src-components-EndChatPage-EndChatFeedback.styles.scss.js';
import { CAContext } from './src-contexts-CAContext.js';
import { getPrivacyPolicyLink } from './src-config-privacy-link.js';

const EndChatFeedback = ({ onStartNewChat, isSessionExpired }) => {
  const {
    chatState: { endChatInfo, locale }
  } = useContext(CAContext);
  const { sendTrackingEvent } = useCustomTracking();
  const [showPopover, setShowPopover] = useState(false);
  const [showAfterFeedback, setShowAfterFeedback] = useState(false);
  const [activeButton, setActiveButton] = useState(null);
  const handleSendFeedback = (feedbackMessage) => {
    sendTrackingEvent("Chatbot Clicked", "Chatbot:Feedback", "endChatFeedbackSubmitted", void 0, {
      feedbackText: feedbackMessage,
      reaction: "down",
      chatbotSessionId: endChatInfo?.sessionId || ""
    });
    setShowPopover(false);
    setShowAfterFeedback(true);
  };
  const handleLike = () => {
    setShowPopover(false);
    setActiveButton("like");
    sendTrackingEvent("Chatbot Clicked", "Chatbot:Feedback", "endChatFeedbackReaction", void 0, {
      reaction: "up",
      chatbotSessionId: endChatInfo?.sessionId || ""
    });
    setShowAfterFeedback(true);
  };
  const handleDislike = () => {
    setShowPopover(true);
    setActiveButton("dislike");
    sendTrackingEvent("Chatbot Clicked", "Chatbot:Feedback", "endChatFeedbackReaction", void 0, {
      reaction: "down",
      chatbotSessionId: endChatInfo?.sessionId || ""
    });
  };
  useEffect(() => {
    if (showPopover) {
      sendTrackingEvent("Chatbot Viewed", "Chatbot:Feedback", "endChatFeedbackTextOpened", void 0, {
        chatbotSessionId: endChatInfo?.sessionId || ""
      });
    }
  }, [showPopover]);
  const handleClosePopover = () => {
    setShowPopover(false);
  };
  return /* @__PURE__ */ React.createElement(FlexBox, { flexDirection: "column", compactMode: true, alignItems: "center", justifyContent: "start", style: { width: "100%", height: "100%" } }, /* @__PURE__ */ React.createElement(FlexBox, { compactMode: true, marginBottom: "7", flexDirection: "column", alignItems: "center", justifyContent: "center", style: { width: "100%" } }, isSessionExpired && /* @__PURE__ */ React.createElement(Box, null, /* @__PURE__ */ React.createElement(AlertBox, { skin: "warning", mb: "4", m: "5", style: { width: "fit-content", maxWidth: "fit-content" } }, "The chat ended after 1 hour without messages. You can start a new one anytime.", " ", /* @__PURE__ */ React.createElement(
    Link,
    {
      render: (p) => /* @__PURE__ */ React.createElement(Button, { skin: "link", className: p.className, onClick: onStartNewChat }, p.children)
    },
    "Start chat"
  ))), /* @__PURE__ */ React.createElement(
    ConversationEvent,
    {
      eventDetails: isSessionExpired ? "Conversation ended automatically" : "Conversation ended",
      timeStamp: (/* @__PURE__ */ new Date()).getTime(),
      width: "100%",
      paddingX: "5"
    }
  ), endChatInfo?.sessionType === "chatbot" && !showAfterFeedback && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Typography, { fontSkin: "title-section", mb: "3", mt: "7" }, "Was Vista Assistant helpful?"), /* @__PURE__ */ React.createElement(Link, { href: getPrivacyPolicyLink(locale, true), mb: "7", target: "_blank" }, "Learn how we use your feedback.", " "), /* @__PURE__ */ React.createElement(FlexBox, { gap: "between-actions" }, /* @__PURE__ */ React.createElement(Button, { onClick: handleLike, className: `chat-feedback-button ${activeButton === "like" ? "active" : ""}` }, /* @__PURE__ */ React.createElement(Icon, { iconType: "like" }), "Yes"), /* @__PURE__ */ React.createElement(Button, { onClick: handleDislike, className: `chat-feedback-button ${activeButton === "dislike" ? "active" : ""}` }, /* @__PURE__ */ React.createElement(Icon, { iconType: "dislike" }), "No")))), " ", endChatInfo?.sessionType == "chatbot" && showPopover && !showAfterFeedback && /* @__PURE__ */ React.createElement(Box, { mb: "7", style: { width: "100%" }, px: "5" }, /* @__PURE__ */ React.createElement(
    FeedbackPopover,
    {
      popoverType: "embed",
      onClose: handleClosePopover,
      onSendFeedback: handleSendFeedback,
      popoverDisplayData: {
        description: " ",
        heading: "Help us improve",
        placeholder: "Tell us what went wrong",
        sendButtonText: "Send feedback"
      },
      showCancelButton: false
    }
  )), endChatInfo?.sessionType === "chatbot" && showAfterFeedback && /* @__PURE__ */ React.createElement(Box, { my: "7" }, /* @__PURE__ */ React.createElement(Typography, { fontSkin: "title-section", mb: "2", textAlign: "center" }, "Thanks for your feedback!"), /* @__PURE__ */ React.createElement(Typography, { fontSkin: "body-standard", textAlign: "center" }, "You just made me a little smarter."), " "), /* @__PURE__ */ React.createElement(Button, { skin: "primary", onClick: onStartNewChat }, "Start new chat"));
};

export { EndChatFeedback as default };
//# sourceMappingURL=src-components-EndChatPage-EndChatFeedback.js.map
